import type {
  AnatomicalPoint,
} from "./anatomicalGeometry";
import {
  geometryPoints,
  isAnatomicalPoint,
} from "./anatomicalGeometry";
import type {
  AnatomicalTemplate,
  AnatomicalTemplateRegion,
  AnatomicalTemplateSex,
  AnatomicalTemplateView,
} from "./anatomicalTemplates";
import type {
  PremiumDraftMarker,
  PremiumMarkerForm,
} from "./anatomicalDraft";

export const REGION_LABELS: Record<AnatomicalTemplateRegion, string> = {
  FULL_BODY: "Cuerpo completo", FACE: "Rostro", NOSE: "Nariz", EAR: "Orejas",
  NECK_DECOLLETE: "Cuello y escote", CHEST_BREAST: "Tórax / mamas",
  ABDOMEN_FLANKS: "Abdomen y flancos", GLUTEAL: "Región glútea",
  ARMS: "Brazos", THIGHS_KNEES: "Muslos y rodillas", SCALP: "Cuero cabelludo",
};

export const SEX_LABELS: Record<AnatomicalTemplateSex, string> = {
  FEMALE: "Femenino", MALE: "Masculino", NEUTRAL: "Neutro",
};

export const VIEW_LABELS: Record<AnatomicalTemplateView, string> = {
  FRONT: "Frente", BACK: "Dorso", LEFT: "Perfil izquierdo", RIGHT: "Perfil derecho",
  THREE_QUARTER_LEFT: "¾ izquierdo", THREE_QUARTER_RIGHT: "¾ derecho",
  INFERIOR: "Basal / inferior", SUPERIOR: "Superior", LATERAL: "Lateral",
  POSTERIOR: "Posterior", ANTERIOR_OBLIQUE: "Oblicua anterior",
  POSTERIOR_OBLIQUE: "Oblicua posterior", FRONTAL_HAIRLINE: "Línea frontal",
  VERTEX: "Vértex", OCCIPITAL: "Occipital", TEMPORAL_LEFT: "Temporal izquierdo",
  TEMPORAL_RIGHT: "Temporal derecho", ANTERIOR_OBLIQUE_LEFT: "Oblicua anterior izquierda",
  ANTERIOR_OBLIQUE_RIGHT: "Oblicua anterior derecha",
};

export function uniqueRegions(templates: AnatomicalTemplate[]): AnatomicalTemplateRegion[] {
  return [...new Set(templates.map((item) => item.region))];
}
export function sexesForRegion(templates: AnatomicalTemplate[], region: AnatomicalTemplateRegion): AnatomicalTemplateSex[] {
  return [...new Set(templates.filter((item) => item.region === region).map((item) => item.sex))];
}
export function templatesForFilters(templates: AnatomicalTemplate[], region: AnatomicalTemplateRegion, sex: AnatomicalTemplateSex): AnatomicalTemplate[] {
  const matches = templates.filter(
    (item) =>
      item.region === region &&
      item.sex === sex
  );

  const latestVersion = Math.max(
    ...matches.map((item) => item.version)
  );

  return matches.filter(
    (item) =>
      item.version === latestVersion
  );
}
function text(value: unknown): string { return value == null ? "" : String(value); }
export function markerFormFromDraft(marker: PremiumDraftMarker): PremiumMarkerForm {
  const planned = marker.planned_treatment || {};
  const details = marker.clinical_details || {};
  return { markerType: marker.marker_type, geometryType: marker.geometry_type,
    administrationId: marker.administration_id == null ? "" : String(marker.administration_id),
    zoneCode: marker.zone_code || "", label: marker.label || "",
    diagnosisText: marker.diagnosis_text || "", treatment: text(planned.treatment),
    product: text(planned.product), equipment: text(planned.equipment),
    dose: text(planned.dose), unit: text(planned.unit), plane: text(planned.plane),
    parameters: text(planned.parameters), notes: text(details.notes), };
}
export function markerPoints(marker: PremiumDraftMarker): AnatomicalPoint[] {
  return isAnatomicalPoint(marker.normalized_geometry)
    ? [{ x: marker.normalized_geometry.x, y: marker.normalized_geometry.y }]
    : geometryPoints(marker.normalized_geometry);
}
